import React from 'react';
import { ILegalPhaseFullObject } from '../../Interfaces/ILegalPhase';
import { Box, MenuItem } from '@mui/material';
import { CustomeTextField } from '../../generic/CustomeTextField';

interface IProps {
  idLegalRequirement: null | number;
  setIdLegalRequirement: Function;
  legalPhases: ILegalPhaseFullObject[];
}

export const SelectRequirement: React.FC<IProps> = ({
  idLegalRequirement,
  setIdLegalRequirement,
  legalPhases,
}) => {
  const getMenuList = () => {
    const children: React.ReactElement[] = [];
    {
      legalPhases.map(phase => {
        children.push(
          <MenuItem
            key={`select-phase-${phase.idLegalPhase}`}
            value={phase.idLegalPhase}
            disabled
          >
            {phase.LegalPhase}
          </MenuItem>
        );
        phase.LegalRequirementArray.map(req => {
          children.push(
            <MenuItem
              key={`select-req-${phase.idLegalPhase}-${req.idLegalRequirement}`}
              value={req.idLegalRequirement}
              disabled={req.idLegalRequirement < 0}
            >
              <Box sx={{ ml: 2 }} />
              {req.LegalRequirement}{' '}
              {req.idLegalRequirement < 0 && ` (Nicht gespeichert)`}
            </MenuItem>
          );
        });
      });
      console.log(children);
      return children;
    }
  };

  return (
    <>
      <CustomeTextField
        label='Maßnahme'
        attr='idLegalRequirement'
        object={{ idLegalRequirement: idLegalRequirement }}
        setObject={(updatedData: { idLegalRequirement: number }) => {
          setIdLegalRequirement(updatedData.idLegalRequirement);
        }}
        type='select'
        null={idLegalRequirement === null}
        children={getMenuList()}
        selectNoValueLabel='Keine Maßnahme ausgewählt'
      />
    </>
  );
};
